[...document.querySelectorAll("select[name='page-number']")].map((select) =>
    select.addEventListener(
        "customSelectChange",
        () => (window.location.href = select.dataset.url + "page/" + select.value + "/?" + select.dataset.query)
    )
);

[...document.querySelectorAll("select[name='order']")].map((select) =>
    select.addEventListener(
        "customSelectChange",
        () => {
            const regex = /(\&)?order=(date|price)\.(asc|desc)/;
            queryWithoutOrder = select.dataset.query.replace(regex, '');
            window.location.href = select.dataset.url + "/?" + queryWithoutOrder + '&order=' + select.value
        }
    )
);
